import AxiosInstance from '../../../http-config'
import { Operacion, OperacionPost, OperacionPatch, OperacionDelete } from '../../model'
import { EnumEstadoOperacionBuyAndSell, EnumTipoOperacion } from '../../enums'
import moment from 'moment'
import { OperationRequest } from '../../requests/operation.request'

import 'moment-timezone'
import {
  BalanceZoneStoreModel,
  CompanyStoreModel,
  getAppConfigurationValue
} from '../../../../redux'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { calculateGasDay } from '../../../../helpers/gasDayHelper'
import { enumValueToKey } from '../../../../helpers'

export const apiOperacionGETById = async (id: number): Promise<Operacion> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/oData/Operaciones?api-version=1.0&$filter=id eq ${id}&$expand=repartos($expand=productoCapacidad),elementoLogistico`
  ).then(response => {
    return response.data.value
  })
}

export const apiOperacionesGETById = async (ids: number[]): Promise<Array<Operacion>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  let filter = ids.map((id: number) => `id eq ${id}`).join(' or ')

  return await AxiosInstance.get(
    `${apiSuffixUrl}/oData/Operaciones?api-version=1.0&$filter=${filter}&$expand=repartos($expand=productoCapacidad)`
  ).then(response => {
    return response.data.value
  })
}

export const apiOperacionesGETByFlangesIds = async (ids: number[]): Promise<Array<Operacion>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  let filter = ids.map((id: number) => `id eq ${id}`).join(' or ')

  return await AxiosInstance.get(
    `${apiSuffixUrl}/oData/Operaciones?&$filter=(${filter})&$expand=elementoLogistico,contraparte,empresa,posicion($expand=trade)&$orderby=fechaOperacion,elementoLogistico/descripcion`
  ).then(response => {
    return response.data.value
  })
}

export const apiOperacionesBuyAndSellGET = async (
  operationTypes: EnumTipoOperacion[] | null,
  startDate: Date | undefined,
  endDate: Date | undefined,
  counterpart: number | undefined,
  stateBuyAndSell: EnumEstadoOperacionBuyAndSell | undefined,
  registerDate: Date | undefined,
  tradeCode: string | undefined,
  balanceZone: BalanceZoneStoreModel | undefined,
  company: CompanyStoreModel | undefined
): Promise<Array<Operacion>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  const operationTypesFilter = operationTypes?.map(operation => `tipoOperacion eq '${operation}'`)
  let filter = operationTypesFilter?.join(' or ')
  filter = `(${filter}) and zonabalance eq '${balanceZone?.code}' and empresa/idempresa eq ${company?.id}`

  if (counterpart) {
    filter += ` and contraparte/id eq ${counterpart}`
  }

  if (stateBuyAndSell) {
    let stateBuyAndSellFilterString: string | undefined
    stateBuyAndSellFilterString = enumValueToKey(EnumEstadoOperacionBuyAndSell, stateBuyAndSell)
    if (isOperationState(stateBuyAndSell)) {
      if (stateBuyAndSell === EnumEstadoOperacionBuyAndSell.Rechazado) {
        filter += ` and (estadoOperacion  eq '${stateBuyAndSellFilterString}' or estadoOperacion eq null)`
      } else {
        filter += ` and estadoOperacion  eq '${stateBuyAndSellFilterString}'`
      }
    } else {
      filter += ` and estadoTSO eq '${stateBuyAndSellFilterString}'`
    }
  }

  if (tradeCode) {
    filter += ` and posicion/trade/codtrade eq '${tradeCode}'`
  }

  if (registerDate) {
    const parsedRegisterDate: string = moment(registerDate).format('YYYY-MM-D')
    filter += ` and Date(fechaAlta) eq ${parsedRegisterDate}`
  }

  if (startDate && endDate) {
    const parseStartDate: string = moment(startDate).format('YYYY-MM-DD')
    const parseEndDate: string = moment(endDate).format('YYYY-MM-DD')

    return await AxiosInstance.get(
      `${apiSuffixUrl}/oData/Operaciones?&$filter=(${filter}) and Date(fechaOperacion) ge ${parseStartDate} and Date(fechaOperacion) le ${parseEndDate} &$expand=elementoLogistico,contraparte,empresa,posicion($expand=trade)&$orderby=fechaOperacion,elementoLogistico/descripcion&keysubtypeoperation=2`
    ).then(response => {
      return response.data.value
    })
  } else return []
}

export const isOperationState = (stateBuyAndSell: EnumEstadoOperacionBuyAndSell): boolean => {
  return (
    stateBuyAndSell === EnumEstadoOperacionBuyAndSell.DP ||
    stateBuyAndSell === EnumEstadoOperacionBuyAndSell.FP ||
    stateBuyAndSell === EnumEstadoOperacionBuyAndSell.FD ||
    stateBuyAndSell === EnumEstadoOperacionBuyAndSell.PendienteRenvio ||
    stateBuyAndSell === EnumEstadoOperacionBuyAndSell.Rechazado ||
    stateBuyAndSell === EnumEstadoOperacionBuyAndSell.Borrador
  )
}

export const apiFetchOperationAllocations = async (
  operationTypes: Array<string>,
  startDate: Date,
  endDate: Date
): Promise<Array<Operacion>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  const operationTypesFilter = operationTypes.map(
    (operation: string) => `tipoOperacion eq '${operation}'`
  )

  return await AxiosInstance.get(
    `${apiSuffixUrl}/oData/Operaciones?api-version=1.0&$expand=repartos($expand=productoCapacidad)&$filter=Date(fechaOperacion) ge ${moment(
      startDate
    ).format('YYYY-MM-DD')} and Date(fechaOperacion) le ${moment(endDate).format(
      'YYYY-MM-DD'
    )} and (${operationTypesFilter?.join(' or ')})`
  ).then(response => {
    return response.data.value
  })
}

export const postOperation = async (operacion: OperacionPost): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  return await AxiosInstance.post(`${apiSuffixUrl}/oData/Operaciones`, operacion).then(response => {
    return response.status
  })
}

export const patchOperation = async (
  operacion: OperacionPatch
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Operations/PatchOperationsBuyAndSell`,
    operacion
  ).then(() => {
    return true
  })
}

export const deleteOperations = async (operation: OperacionDelete): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  return await AxiosInstance.delete(
    `${apiSuffixUrl}/oData/Operaciones(${operation.id},'${operation.tipoOperacion}')`
  ).then(() => {
    return true
  })
}

export const patchStateOperation = async (operacion: OperationRequest): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  return await AxiosInstance.patch(
    `${apiSuffixUrl}/oData/Operaciones(${operacion.id},'${operacion.tipoOperacion}')`,
    operacion
  ).then(() => {
    return true
  })
}

export const apiOperacionesPATCH = async (request: OperationRequest): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

  return await AxiosInstance.patch(
    `${apiSuffixUrl}/oData/Operaciones(${request.id},'${request.tipoOperacion}')`,
    request
  ).then(() => {
    return true
  })
}
